import React, { Component } from 'react';
import axios from 'axios';
import { API_URL } from 'helpers/variables';
import { authConfig } from 'helpers/authConfig';
import alerts from 'locales/alerts';
import { success, warning, error } from 'react-notification-system-redux';

import { store } from 'index';
import * as _ from 'lodash';

let def = 'en';

class PublishChanges extends Component {
    constructor(props) {
        super(props);
        

        this.state = {
            loading: false,
            has_unpublished_changes: false,
            yacht_id: props.yacht_id,
            lastSucessfulUpdate: props.lastSucessfulUpdate
        };
    }

    componentDidMount() {
        this.refreshState()
    }

    refreshState() {
        if (!this.props.yacht_id) {
            return;
        }
        axios
            .get(API_URL + '/yachts/'+ this.props.yacht_id +'/has-unpublished-changes', {
                headers: authConfig()
            })
            .then((res) => {
                this.setState({ has_unpublished_changes: res.data.hasUnpublishedChanges });
            });
    }

    componentDidUpdate(prev) {
        if (prev.lastSucessfulUpdate !== this.props.lastSucessfulUpdate) {
            setTimeout(() => {
                this.refreshState()
            },100)
        }
    }

    handlePublish = async () => {
        this.setState({ loading: true });

        const config = {
            headers: authConfig()
        };

        const {yacht_id} = this.state; 
        return await axios
            .post(`${API_URL}/yachts/${yacht_id}/publish`, {}, config)
            .then(async (response) => {
                if (response.data && !response.data.error) {

                            store.dispatch(
                                success({
                                    title: 'Success',
                                    message: 'Changes published succesfully'
                                })
                            );
                } else if (response.data) {

                let successWebhooks = [];
                let failedWebhooks = [];
                _.each(response.data.data, function (r) {
                    if (r.status !== 'OK') {
                        failedWebhooks.push(r);
                    } else {
                        successWebhooks.push(r);
                    }
                });

                if (successWebhooks.length === 0) {
                    store.dispatch(
                        error({
                            title: 'ERROR!',
                            message: 'All Webhooks failed to update, or no webhooks enabled'
                        })
                    );
                } else {

                    store.dispatch(
                        warning({
                            title: 'Warning',
                            message: _.reduce(failedWebhooks, function(prev, wh, key) {
                                return `${prev} ${wh.name}` + (key === failedWebhooks.length - 1 ? '.' : ' ')
                            }, 'Webhooks Failed: ') + ' Failed webhook changes will propagate when failed servers are online'
                        }) 
                    );
                }

                }
            })
            .catch((err) => {
                store.dispatch(
                    error({
                        title: 'ERROR',
                        message: 'Some unknown error occured'
                    })
                );
            })
            .finally(async () => {
                await this.refreshState();
                this.setState({ loading: false });
            });
    };

    render() {
        const { loading, has_unpublished_changes} = this.state;
        
        return (
            <div className={'clearWebsiteCache'} style={{display: "block"}}>
                <button
                    disabled={loading || !has_unpublished_changes}
                    className="btn btn-danger"
                    onClick={this.handlePublish}
                >
                    {loading ? (
                        <i className="fa fa-spinner fa-pulse " />
                    ) : (
                        <span>Publish Changes</span>
                    )}
                </button>
            </div>
        );
    }
}

export default PublishChanges;
